import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Typography,
    Card, CardContent, Box, Divider
} from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import {fetchProgramPreviewService} from "../../../services/program.service";
import {useParams} from "react-router-dom";
import {ArrowDropDown, ArrowDropUp} from "@material-ui/icons";
const useStyles = makeStyles((theme) => ({
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        marginBottom: '10px !important',
        marginTop: '20px',
        fontSize: '35px !important',
    },
    list: {
        listStyleType: "none",
        paddingLeft: 0,
        margin: 0,
        width: "100%",
    },
    listItem: {
        fontSize: "19px",
        color: "#5A5A5A",
        marginBottom: "10px",
        lineHeight: "1.6",
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        marginTop: '15px',
    },
    button: {
        margin: '10px !important',
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%)",
        width: '100% !important',
        padding: '10px !important',
        color: '#fff !important',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%)",
            color: '#fff !important',
        },
    },
    card: {
        marginTop:'10px !important',
        marginBottom: '15px',
        backgroundColor: '#F8F8F8',
        borderRadius: '10px',
        cursor: 'pointer',
        color: '#002060',
        boxShadow:'none',
    },
    cardContent: {
        color: '#002060',
        paddingBottom:'16px !important',
    },
    unitTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#EE6628',
        textAlign: 'center',
        padding: '10px',
    },
    lessonContainer: {
        paddingLeft: '20px',
    },
    sectionRow: {
        marginTop:'20px',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '5px 0',
        alignItems: 'center',
    },
    lessonRow: {
        marginTop:'0px',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '5px 0',
        alignItems: 'center',
},
    sectionText: {
        fontWeight:'500',
        fontSize:'17px !important',
        color: '#002060',
    },
    downloadButton: {
        backgroundColor: '#ef6528 !important',
        color: '#fff',
        padding: '5px 15px !important',
        width:'135px !important',
        '&:hover': {
            backgroundColor: '#e44d1f !important',
        },
    },
    disabledButton: {
        backgroundColor: '#ccc !important',
        color: '#666 !important',
        cursor: 'not-allowed',
        margin: '10px !important',
        width: '100% !important',
        padding: '10px !important',
    },
}));

// API Integration
export const ApiIntegration = ({ open, onClose }) => {
    const classes = useStyles();
    return (
        <Dialog maxWidth="md"
                fullWidth PaperProps={{
            style: {
                width: '40%',
                height: '35%',
                maxWidth: 'none',
            },
        }} open={open} onClose={onClose}>
            <DialogTitle className={classes.title}>API Integration</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    If you are integrating via API, you can find the documentation below to help with integration of the assessments into your system. If you need further technical support, please reach out to{' '}
                    <a href="mailto:tech@dqforall.com">tech@dqforall.com</a>{' '}.
                </DialogContentText>
                <Typography variant="body1" style={{ marginTop: '15px', textAlign: 'left', fontWeight: 'bold' }}>
                    <span style={{fontWeight:'bold',color:'#ef6528'}}>API Key:</span> 5f96e7a9-62f3-419f-9e88-8e2978e94c01
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button style={{color:'#ef6528'}} onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

// EducationMaterial Dialog
export const EducationMaterial = ({ open, onClose, onPPTDownload }) => {
    const classes = useStyles();
    const handleDownloadPDF = () => {
        console.log('Downloading PDF...');
    };

    const handleDownloadWord = () => {
        console.log('Downloading Word...');
    };

    const handleDownloadPowerPoint = () => {
        onPPTDownload();
        console.log('Downloading PowerPoint...');
    };

    return (
        <Dialog  maxWidth="md"
                 fullWidth PaperProps={{
            style: {
                width: '40%',
                height: '40%',
                maxWidth: 'none',
            },
        }} open={open} onClose={onClose}>
            <DialogTitle className={classes.title}>Education Material</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Access and download your program materials in multiple formats (PDF, Word, and PowerPoint)  for easy sharing and presentation.
                </DialogContentText>
                <div className={classes.buttonContainer}>
                    {/* Download PDF Button */}
                    <Button
                        variant="contained"
                        color="primary"
                        disabled
                        className={classes.disabledButton}
                        onClick={handleDownloadPDF}
                    >
                        Download PDF
                    </Button>

                    {/* Download Word Button */}
                    <Button
                        variant="contained"
                        color="primary"
                        disabled
                        className={classes.disabledButton}
                        onClick={handleDownloadWord}
                    >
                        Download Word (DOCX)
                    </Button>

                    {/* Download PowerPoint Button */}
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={handleDownloadPowerPoint}
                    >
                        Download PowerPoint (PPTX)
                    </Button>
                </div>
            </DialogContent>
            <DialogActions>
                <Button style={{color:'#ef6528'}} onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

// ContentVideos Dialog
export const ContentVideos = ({ open, onClose }) => {
    const classes = useStyles();
    const [unitsData, setUnitsData] = useState([]);
    const [sessionsData, setSessionsData] = useState([]);
    const [modulesData, setModulesData] = useState([]);
    const [openModules, setOpenModules] = useState({});
    const [openUnits, setOpenUnits] = useState({});
    const { programId } = useParams();
    useEffect(() => {
        (async () => {
            if (programId) {
                try {
                    const result = await fetchProgramPreviewService(programId);
                    if(result.data) {
                        setModulesData(result.data.modulesData);
                        setUnitsData(result.data.unitsData);
                        setSessionsData(result.data.sessionsData);
                    }
                } catch (error) {
                    console.error('Failed to fetch program status:', error);
                }
            }
        })();
    }, [programId]);

    const handleToggleModuleDropdown = (moduleIndex) => {
        setOpenModules((prev) => ({
            ...prev,
            [moduleIndex]: !prev[moduleIndex],
        }));
    };

    // Toggle unit dropdown
    const handleToggleUnitDropdown = (moduleIndex, unitIndex) => {
        setOpenUnits((prev) => ({
            ...prev,
            [`${moduleIndex}-${unitIndex}`]: !prev[`${moduleIndex}-${unitIndex}`],
        }));
    };

    // Handle download lesson
    const handleDownloadLesson = (lesson) => {
        console.log('Downloading lesson:', lesson);
    };
    return (
        <Dialog maxWidth="md"
                fullWidth PaperProps={{
            style: {
                width: '50%',
                height: '58%',
                maxWidth: 'none',
            },
        }} open={open} onClose={onClose}>
            <DialogTitle className={classes.title}>Your Videos</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Download program videos in MP4 format for seamless playback.
                </DialogContentText>
                {modulesData.map((module, moduleIndex) => (
                    <Card className={classes.card} key={module.module_code}>
                        <CardContent className={classes.cardContent}>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                onClick={() => handleToggleModuleDropdown(moduleIndex)}
                                style={{ cursor: 'pointer' }}
                            >
                                <Typography variant="h6" style={{ fontSize: '1.3rem', color: '#ED6628' }}>
                                    {`${module.module_name}`}
                                </Typography>
                                {openModules[moduleIndex] ? (
                                    <ArrowDropUp style={{ color: '#D35400' }} />
                                ) : (
                                    <ArrowDropDown style={{ color: '#D35400' }} />
                                )}
                            </Box>

                            {openModules[moduleIndex] && (
                                <>
                                    {module.units.map((unit, unitIndex) => (
                                        <Card style={{boxShadow:'none'}} key={unit.unit_code}>
                                            <CardContent>
                                                <Box
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                    onClick={() => handleToggleUnitDropdown(moduleIndex, unitIndex)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Typography variant="h6" style={{ color: '#e7456d' }}>
                                                        {`${unit.unit_title}`}
                                                    </Typography>
                                                    {openUnits[`${moduleIndex}-${unitIndex}`] ? (
                                                        <ArrowDropUp style={{ color: '#ED6628' }} />
                                                    ) : (
                                                        <ArrowDropDown style={{ color: '#ED6628' }} />
                                                    )}
                                                </Box>

                                                {openUnits[`${moduleIndex}-${unitIndex}`] && (
                                                    <>
                                                        <Divider
                                                            style={{
                                                                height: '4px',
                                                                marginTop: '10px',
                                                                backgroundColor: '#F17632',
                                                                borderRadius: '15px',
                                                            }}
                                                        />
                                                        {unit.lessons.map((lesson) => (
                                                            <Box
                                                                className={classes.lessonContainer}
                                                                key={lesson.lesson_code}
                                                                style={{ paddingBottom: '8px' }}
                                                            >
                                                                <Box className={classes.sectionRow}>
                                                                    <Typography
                                                                        variant="h4"
                                                                        className={classes.sectionText}
                                                                    >
                                                                        {`${lesson.lesson_title}`}
                                                                    </Typography>
                                                                    <Button
                                                                        variant="contained"
                                                                        className={classes.downloadButton}
                                                                        onClick={() => handleDownloadLesson(lesson)}
                                                                    >
                                                                        Download
                                                                    </Button>
                                                                </Box>
                                                            </Box>
                                                        ))}
                                                    </>
                                                )}
                                            </CardContent>
                                        </Card>
                                    ))}
                                </>
                            )}
                        </CardContent>
                    </Card>
                ))}
            </DialogContent>
            <DialogActions>
                <Button style={{color:'#ef6528'}} onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};